module.exports = __webpack_public_path__ + "img/button-back.67468edc.svg";